// removed by extract-text-webpack-plugin
module.exports = {"label":"_1XeOx8En3EOnW6VKOiTJ_w","input":"_3VNk0gTOE52SPTt0iH6mvt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Input/Input.styl
// module id = 127
// module chunks = 0